import Box from '@components/base/Box'
import React, { useEffect } from 'react'
export type GoogleAdsProps = {
  type: 'horizontal' | 'vertical' | 'square'
  show?: boolean
  className?: string
}

declare global {
  interface Window {
    adsbygoogle: { [key: string]: unknown }[]
  }
}

const ADS_ENABLED = process.env.NEXT_PUBLIC_ENABLE_ADS
const DEBUG_MODE = false

export const GoogleAds = ({
  type,
  show = true,
  className = '',
}: GoogleAdsProps) => {
  useEffect(() => {
    try {
      if (!show) return
      if (typeof window !== 'undefined') {
        if (!window.adsbygoogle) window.adsbygoogle = []

        window.adsbygoogle.push({})

        console.log({ ads: window.adsbygoogle })
      } else console.log('[GoogleAds]: No window object.')
    } catch (err) {
      if (DEBUG_MODE) console.log(err)
      else console.log('Ad Error Suppressed.')
    }
  }, [])

  if (ADS_ENABLED?.toLowerCase() !== 'true' || !show) return <></>

  if (type === 'square')
    return (
      <Box className={`${className}`}>
        <ins
          className={`adsbygoogle gad_sign_up_page`}
          style={{
            // display: 'inline-block',
            display: 'block',
            // height: '90px',
            // width: '100%',
            outline: DEBUG_MODE ? '1px solid red' : 'none',
          }}
          data-ad-client="ca-pub-3643756915754911"
          data-ad-slot="9657998552"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </Box>
    )

  if (type === 'vertical')
    return (
      <Box className={`${className}`}>
        <ins
          className={`adsbygoogle gad_sign_up_page`}
          style={{
            display: 'inline-block',
            height: '100%',
            width: '300px',
            outline: DEBUG_MODE ? '1px solid red' : 'none',
          }}
          data-ad-client="ca-pub-3643756915754911"
          data-ad-slot="3092590200"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </Box>
    )

  if (type === 'horizontal')
    return (
      <Box className={`${className}`}>
        <ins
          className={`adsbygoogle gad_sign_up_page`}
          style={{
            display: 'inline-block',
            height: '90px',
            width: '100%',
            outline: DEBUG_MODE ? '1px solid red' : 'none',
          }}
          data-ad-client="ca-pub-3643756915754911"
          data-ad-slot="2515404500"
          data-ad-format="inline"
          data-full-width-responsive="false"
        ></ins>
      </Box>
    )

  return <></>
}
